import { useFormik } from "formik";
import { useCallback, useState } from "react";
import { signupFormValidationSchema } from "../constant/formValidationSchema";
import { ERROR_MESSAGES } from "../constant/messages";
// import dayjs from "dayjs";
import { postSignUpFormData } from "../services/form.service";

const useSignupForm = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const filterValues = useCallback((obj) => {
    const { isEighteenOrOlder, ...rest } = obj;
    return rest;
  }, []);

  const handleErrorFalse = useCallback(() => {
    setError(false);
  }, []);

  const formik = useFormik({
    initialValues: {
      userType: "",
      businessType: "Individual",
      gender: "",
      // DOB: null,
      mobileNumber: "",
      serviceId: "",
      name: "",
      businessName: "",
      experience: "",
      serviceOrCurrentLocationObject: {},
      homeLocationObject: {},
      isEighteenOrOlder: false,
      isAutoApproved: true,
      otp: Array(4).fill(""),
    },
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: signupFormValidationSchema,
    validateOnChange: true,

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formattedMobileNumber = values?.mobileNumber?.startsWith("+91")
          ? values?.mobileNumber
          : "+91" + values?.mobileNumber;
        // const formattedDOB = dayjs(values?.DOB).format(
        //   "YYYY-MM-DDT00:00:00[Z]"
        // );
        const filteredValues = filterValues(values);
        if (filteredValues.userType === "User") {
          const keysToDelete = [
            "businessType",
            "serviceId",
            "businessName",
            "experience",
            "isAutoApproved",
          ];
          keysToDelete.forEach((key) => delete filteredValues[key]);
        }

        // Conditionally remove businessName if businessType is "Individual"
        if (filteredValues.businessType === "Individual") {
          delete filteredValues?.businessName;
        }

        const payload = {
          ...filteredValues,
          // DOB: formattedDOB,
          mobileNumber: formattedMobileNumber,
          otp: values?.otp.join(""),
        };
        const res = await postSignUpFormData(payload);
        if (res?.data?.message === "Registration Successful") {
          return true;
        }
      } catch (error) {
        setError(true);
        setErrorMessage(error?.response?.data?.message);
        console.error(ERROR_MESSAGES?.postDataError, error);
        return false;
      } finally {
        setLoading(false);
      }
    },
  });
  return {
    formik,
    loading,
    errorMessage,
    handleErrorFalse,
    error,
  };
};

export default useSignupForm;
